module.exports = __webpack_public_path__ + "static/media/svg-4.7792c146.svg";